import { useState } from 'react'
import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import {
    RiDashboardLine,
    RiPriceTag3Line,
    RiRulerLine,
    RiMoneyDollarCircleLine,
    RiShoppingCartLine,
    RiTruckLine,
    RiArrowLeftLine,
    RiMenuLine,
    RiCloseLine,
    RiMenuFoldLine,
    RiMenuUnfoldLine,
} from 'react-icons/ri'
import { useIsMobile } from '@/hooks/useIsMobile'
import { ROUTES } from '@/constants/routes'
import styles from './AdminLayout.module.css'

const adminNavItems = [
    { path: ROUTES.adminDashboard, label: 'Dashboard', icon: RiDashboardLine },
    { path: ROUTES.adminOrders, label: 'Pedidos', icon: RiShoppingCartLine },
    { path: ROUTES.adminShipping, label: 'Envíos', icon: RiTruckLine },
    { path: ROUTES.adminMaterials, label: 'Materiales', icon: RiPriceTag3Line },
    { path: ROUTES.adminSizes, label: 'Tamaños', icon: RiRulerLine },
    { path: ROUTES.adminPrices, label: 'Precios', icon: RiMoneyDollarCircleLine },
]

export function AdminLayout() {
    const navigate = useNavigate()
    const isMobile = useIsMobile()
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [collapsed, setCollapsed] = useState(false)

    const handleNavClick = () => {
        if (isMobile) {
            setSidebarOpen(false)
        }
    }

    const sidebarClass = [
        styles.sidebar,
        sidebarOpen ? styles.sidebarOpen : '',
        !isMobile && collapsed ? styles.sidebarCollapsed : '',
    ].filter(Boolean).join(' ')

    const mainClass = [
        styles.main,
        !isMobile && collapsed ? styles.mainCollapsed : '',
    ].filter(Boolean).join(' ')

    return (
        <div className={styles.layout}>
            {/* Mobile top bar */}
            <div className={styles.mobileHeader}>
                <button
                    className={styles.menuToggle}
                    onClick={() => setSidebarOpen((prev) => !prev)}
                    aria-label={sidebarOpen ? 'Cerrar menú' : 'Abrir menú'}
                >
                    {sidebarOpen ? <RiCloseLine /> : <RiMenuLine />}
                </button>
                <span className={styles.mobileTitle}>Panel de Administración</span>
            </div>

            {/* Backdrop overlay for mobile */}
            {isMobile && sidebarOpen && (
                <div
                    className={styles.backdrop}
                    onClick={() => setSidebarOpen(false)}
                    aria-hidden="true"
                />
            )}

            <aside className={sidebarClass}>
                <div className={styles.sidebarHeader}>
                    <h2 className={styles.title}>Panel de Administración</h2>
                    <button
                        className={styles.backButton}
                        onClick={() => navigate(ROUTES.home)}
                    >
                        <RiArrowLeftLine />
                        <span className={styles.backLabel}>Volver al sitio</span>
                    </button>
                </div>

                <nav className={styles.nav}>
                    {adminNavItems.map((item) => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            className={({ isActive }) =>
                                `${styles.navLink} ${isActive ? styles.active : ''}`
                            }
                            onClick={handleNavClick}
                            title={collapsed && !isMobile ? item.label : undefined}
                        >
                            <item.icon />
                            <span className={styles.navLabel}>{item.label}</span>
                        </NavLink>
                    ))}
                </nav>

                {/* Desktop collapse toggle */}
                {!isMobile && (
                    <button
                        className={styles.collapseToggle}
                        onClick={() => setCollapsed((prev) => !prev)}
                        aria-label={collapsed ? 'Expandir barra lateral' : 'Colapsar barra lateral'}
                        title={collapsed ? 'Expandir' : 'Colapsar'}
                    >
                        {collapsed ? <RiMenuUnfoldLine /> : <RiMenuFoldLine />}
                    </button>
                )}
            </aside>

            <main className={mainClass}>
                <Outlet />
            </main>
        </div>
    )
}
